import { style } from "@vanilla-extract/css";

import { theme } from "./theme.css";

export const visualDebugContainerStyle = style({
  position: "relative",
  ":before": {
    content: "",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    outline: `1px dashed ${theme.colors.error}`,
    outlineOffset: "-1px",
    borderRadius: "6px",
    zIndex: 10,
    pointerEvents: "none",
  },
});
